// extracted by mini-css-extract-plugin
export default {"container":"MenuBar_container__g0riY","lang_hori":"MenuBar_lang_hori__8efD9","web_container":"MenuBar_web_container__PeeRd"};